export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    DashboardSlots: 'specs.events.ui.DashboardSlots',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled', // Disables fees on offline payment, disable to prevent order update on paymentMethod change.
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    DisableRicos: 'specs.events.ui.DisableRicos',
    GetRichContentByEventId: 'specs.events.ui.GetRichContentByEventId',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    UpdatePaymentTermsSquare: 'specs.events.ui.UpdatePaymentTermsSquare',
    SettingsPanelUpdatedTranslations: 'specs.events.ui.SettingsPanelUpdatedTranslations', // false 100%, 2024,07-12
    DisableEventCreationForPaypal: 'specs.events.ui.DisableEventCreationForPaypal',
    DescriptionVisibility: 'specs.events.ui.DescriptionVisibility', // false 100%, 2024-07-12
    AddMultipleGuestsManually: 'specs.events.ui.AddMultipleGuestsManually',
    SingleEventNoRegistrationTextSetting: 'specs.events.ui.SingleEventNoRegistrationTextSetting', // English 100%, 2024-07-12
    BMContentUpdates: 'specs.events.ui.BMContentUpdates', // English 100%, 2024-07-12
    TicketMoreInfoButtonSetting: 'specs.events.ui.TicketMoreInfoButtonSetting',
    AiAssistant: 'specs.events.ui.AiEventsAssistant',
    AiTicketsAssistant: 'specs.events.ui.AiTicketsAssistant',
    NewPolicyFontColor: 'specs.events.ui.NewPolicyFontColor',
    ServiceFeeEnforcementUpdates: 'specs.events.ui.ServiceFeeEnforcementUpdates',
    UpdatedCheckoutSummary: 'specs.events.ui.UpdatedCheckoutSummary',
    CategoriesUXImprovements: 'specs.events.ui.CategoriesUXImprovements',
    GuestListDefaultSort: 'specs.events.ui.GuestListDefaultSort',
    AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
    OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
    WidgetSEOTags: 'specs.events.ui.WidgetSEOTags',
    AddMultipleGuestsManuallyRSVP: 'specs.events.ui.AddMultipleGuestsManuallyRSVP',
    UpdateTicketResendFlow: 'specs.events.ui.UpdateResendTicketFlow',
    MemberOnlyEventError: 'specs.events.ui.MemberOnlyEventError',
    UpdateOrderSuccessContent: 'specs.events.ui.UpdateOrderSuccessContent',
    UpdateSettingsPanelIllustrations: 'specs.events.ui.UpdateSettingsPanelIllustrations',
    DisableMobileFontOverrides: 'specs.events.ui.DisableMobileFontOverrides',
    UnauthorizedErrorPage: 'specs.events.ui.UnauthorizedErrorPage',
    UpdateServiceFeeConfigDesign: 'specs.events.ui.UpdateServiceFeeConfigDesign',
    UpdateGuestEmail: 'specs.events.ui.UpdateGuestEmail',
    UpdateTicketListEmptyState: 'specs.events.ui.UpdateTicketListEmptyState',
    GroupConnectedToEventPrivacy: 'specs.groups.GroupConnectedToEventPrivacy',
    UseGuestsService: 'specs.events.ui.UseGuestsService',
    WixLiveTerminationWarnings: 'specs.events.ui.WixLiveTerminationWarnings',
    FixPaidPlans: 'specs.events.ui.FixPaidPlans',
    UpdateDisplayEventsLabel: 'specs.events.ui.UpdateDisplayEventsLabel',
    DisableMembershipEntryForDraftEvents: 'specs.events.ui.DisableMembershipEntryForDraftEvents',
    AddEditRegistrationFormStep: 'specs.events.ui.AddEditRegistrationFormStep',
    DonationKeyboardMode: 'specs.events.ui.DonationKeyboardMode',
    AddPageTitles: 'specs.events.ui.AddPageTitles',
    FixContentOrder: 'specs.events.ui.FixContentOrder',
    DelayedPayments: 'specs.events.ui.DelayedPaymentCapture',
    SeeAllGuestsLink: 'specs.events.ui.SeeAllGuestsLink',
    TicketDefinitionNamePrefilled: 'specs.events.ui.TicketDefinitionNamePrefilled',
};
//# sourceMappingURL=experiments.js.map